import getFetchOptions from 'utils/getFetchOptions';

import { handleResponse } from '../utils';
import { CreateMerchantUserRequest, MerchantUser, UpdateMerchantUserRequest } from './merchant.users.types';

export const getMerchantUsers = async (apiBaseUri: string, merchantId: string): Promise<Array<MerchantUser>> => {
  const options = await getFetchOptions('GET');

  return await fetch(`${apiBaseUri}/authn/list-merchant-user/merchants/${merchantId}`, options).then(handleResponse);
};

export const createMerchantUser = async (apiBaseUri: string, payload: CreateMerchantUserRequest): Promise<void> => {
  const options = await getFetchOptions('POST', JSON.stringify(payload));
  return await fetch(`${apiBaseUri}/authn/create-merchant-user`, options).then(handleResponse);
};

export const updateMerchantUser = async (apiBaseUri: string, payload: UpdateMerchantUserRequest): Promise<void> => {
  const options = await getFetchOptions('POST', JSON.stringify(payload));
  return await fetch(`${apiBaseUri}/authn/update-merchant-user`, options).then(handleResponse);
};
